<template>
	<b-card no-body>
		<b-card-header class="border-0">
			<b-row></b-row>
		</b-card-header>

		<b-col cols="12">
			<b-row class="d-flex align-items-center justify-content-md-between">
				<b-col cols="12" md="8" class="d-md-flex">
					<base-input label="Search" v-model="searchQuery" v-on:input="debouncedHandler" placeholder="Search">
					</base-input>
					<base-input label="Filter by Status" class="mx-4">
						<el-select v-model="referral_status" multiple collapse-tags placeholder="Select Status"
							@change="filterByMainStatus()">
							<el-option v-for="item in referralStatusList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</base-input>
				</b-col>
				<b-col cols="12" md="4">
					<b-row class="d-flex align-items-center justify-content-md-end">
						<b-col cols="auto" class="mb-3">
							<el-button class="float-right px-3 py-2 mb-2 mb-md-0" type="gray" plain>
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
									<path fill="currentColor"
										d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
								</svg>
								Filters
							</el-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-col>

		<div class="table-listings">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="selectionChange"
				class="mt-4" v-loading="isTableLoading">
				<el-table-column type="selection" width="45"></el-table-column>

				<!-- <el-table-column width="70" class-name="icons-chat">
						<template slot-scope="scope">
							<MessagingBoxButton :type="'invinity_customer'" :profile="scope.row" />
						</template>
				</el-table-column> -->

				<el-table-column label="Fund Ref. No/ Fund Name" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<div>
							<div class="d-flex align-items-center">
								<el-tooltip effect="dark" placement="right">
									<div slot="content" class="d-flex align-items-center">
										{{ scope.row.ref_no }}
										<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer ml-2"
											@click.prevent="copyToClipboard(scope.row.ref_no)" width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
										</svg>
									</div>
									<router-link :to="'/funds_management/investors_profile/detail?active=overview'">
										<p class="top-line text-primary">{{ scope.row.ref_no }}</p>
									</router-link>
								</el-tooltip>
							</div>
							<div class="d-flex align-items-center">
								<p class="bottom-line">{{ scope.row.fund_name }}</p>
							</div>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="Referee/ ID" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">{{ scope.row.referee_name }}</p>
						<p class="bottom-line">{{ scope.row.referee_id }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Status" min-width="150">
					<template slot-scope="scope">
						<p class="top-line">{{ scope.row.status }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Fund Amt./ Release Term" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">RM {{ scope.row.fund_amt | moneyFormatter }}</p>
						<p class="bottom-line">{{ scope.row.release_term }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Invest Date/ End Date" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">RM {{ scope.row.invest_date }}</p>
						<p class="bottom-line">{{ scope.row.end_date }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Pending Amt./ Paid Date" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">RM {{ scope.row.pending_amt | moneyFormatter }}</p>
						<p class="bottom-line">{{ scope.row.paid_date }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Total Paid Amt." min-width="150">
					<template slot-scope="scope">
						<p class="top-line">RM {{ scope.row.total_paid_amt | moneyFormatter }}</p>
					</template>
				</el-table-column>

				<el-table-column fixed="right" width="25" align="center" class-name="px-0">
					<template>
						<el-dropdown trigger="click" style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>
									<!-- Eye Icon -->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
										<path fill="#13663E"
											d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
									</svg>
									View Change Log
								</el-dropdown-item>
								<el-dropdown-item>
									<span class="text-danger">
										<!-- Trash-Can Icon -->
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
											<path fill="#DF3030"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
										</svg>
										Delete
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button } from 'element-ui'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'

export default {
	mixins: [clientPaginationMixin],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		[Tooltip.name]: Tooltip,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Button.name]: Button,
	},
	data() {
		return {
			propsToSearch: [''],
			pending_only: false,
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			isTableLoading: false,
			isFixed: true,
			tableData: [
				{
					ref_no: 'ICSB_JVF-#003119',
					fund_name: 'JV Fund 1.0 - 15%',
					referee_name: 'Karen Chin',
					referee_id: 1917,
					status: 'In-Progressive',
					fund_amt: 64000,
					release_term: 'Half Yearly',
					invest_date: '27 Jul 2023',
					end_date: '27 Jul 2025',
					pending_amt: 2560,
					paid_date: '27 Jul 2024',
					total_paid_amt: 5120
				}
			],
			referralStatusList: [{
				value: 'In-Progressive',
				label: 'In-Progressive'
			}, {
				value: 'Completed',
				label: 'Completed'
			}],
			referral_status: [],
		}
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			// this.searchFinancialProposalList();
		}, 500);
	},
	methods: {
		paginationChanged(page) {
			this.pagination.currentPage = page
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		filterByMainStatus(event) {
		},
		copyToClipboard(value) {
			const tempInput = document.createElement('input');
			tempInput.value = value;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);

			_gNotif.notifySuccess(value + '<br>Copied to Clipboard.')
		},
	}
}
</script>